<template>
  <footer class="st-Footer">
    <div class="st-Footer_Pagetop" @click="goTop"><i class="el-icon-arrow-up"></i></div>
    <div class="st-Footer_Inner">
      <nav class="st-FtDirectory">
        <div class="st-FtDirectory_Logo"><a href="/"><img src="../../../static/img/landing/logo_white.png" alt=""></a></div>
        <div class="st-FtDirectory_Column">
          <h3 class="st-FtDirectory_Column-title" style="width:200px">COMPANY<i></i></h3>
          <ul class="st-FtDirectory_Column-list">
            <li><a href="/company">企業情報</a></li>
          </ul>
        </div>
        <div class="st-FtDirectory_Column">
          <h3 class="st-FtDirectory_Column-title" style="width:200px">PRODUCT<i></i></h3>
          <ul class="st-FtDirectory_Column-list">
            <li><a href="/product/product-0001">光学曲線研削加工</a></li>
            <li><a href="/product/product-0002">精密ワイヤーカット</a></li>
            <li><a href="/product/product-0003">精密平面研削</a></li>
          </ul>
        </div>
        <div class="st-FtDirectory_Column">
          <h3 class="st-FtDirectory_Column-title" style="width:200px">INNOVATION<i></i></h3>
          <ul class="st-FtDirectory_Column-list">
            <li><a href="/innovation">経営革新</a></li>
          </ul>
        </div>
        <div class="st-FtDirectory_Column">
          <h3 class="st-FtDirectory_Column-title" style="width:200px">RECRUIT<i></i></h3>
          <ul class="st-FtDirectory_Column-list">
            <li><a href="/recruit">採用情報</a></li>
          </ul>
        </div>
        <div class="st-FtDirectory_Column">
          <h3 class="st-FtDirectory_Column-title" style="width:200px">CONTACT US<i></i></h3>
          <ul class="st-FtDirectory_Column-list">
            <li><a href="/contactus">お問い合わせ</a></li>
          </ul>
        </div>
      </nav>
      <div class="st-FtPress">
        <div class="st-FtDirectory_Column st-FtPress-contactus"><a href="javascript:void(0)"><img src="../../../static/img/landing/address.png">
          </a>
          <p class="st-FtPress_Logo" style="padding-left: 10px;">〒436-0016 掛川市板沢1945番地の11</p>
        </div>
        <div class="st-FtDirectory_Column st-FtPress-contactus"><a href="javascript:void(0)"><img src="../../../static/img/landing/phone.png">
          </a>
          <p class="st-FtPress_Logo" style="padding-left: 10px;">TEL:(86)573-8205-8763</p>
        </div>
        <div class="st-FtDirectory_Column st-FtPress-contactus" style="width:150px;"><a href="javascript:void(0)"><img src="../../../static/img/landing/mail.png">
          </a>
          <p class="st-FtPress_Logo" style="padding-left: 10px;">j0230500@yahoo.co.jp</p>
        </div>
      </div><!-- /.st-FtPress -->
    </div>
    <div class="st-FtLegal pt-5">
      <div class="st-FtLegal_Inner">
        <div class="st-FtLegal_Left">
        </div>
        <div class="st-FtLegal_Right">
          <ul class="st-FtLegal_Link">
            <li><a href="/policy">サイトポリシー</a></li>
            <li><a href="/privacy">プライバシーポリシー</a></li>
          </ul>
          <p style="margin-bottom: 0rem;" class="st-FtLegal_Copyright pb-5 pb-md-0"><small>&copy; 2021 NICECERA</small></p>
        </div>
      </div> <!-- /.st-FtLegal_Inner -->
    </div><!-- /.st-FtLegal -->
  </footer>
</template>

<style />

<script type="text/javascript">
import Swiper from "swiper/swiper-bundle.js";
import "swiper/swiper-bundle.css";
export default {
  data: function() {
    return {
      stFtPressSwiper: ""
    };
  },
  mounted() {
    let stFtPressSwiperSettings = {
      initialSlide: 1,
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto",
      effect: "coverflow",
      scrollbar: {
        el: ".st-FtPress_Slide-scrollbar",
        draggable: true,
        snapOnRelease: true
      }
    };
    this.stFtPressSwiper = new Swiper(
      ".st-FtPress_Slide",
      stFtPressSwiperSettings
    );

    $(".st-FtDirectory_Column-title").on("click", function() {
      if (!$(this).hasClass("no-slide")) {
        $(this).toggleClass("is-open");
        $(this)
          .next(".st-FtDirectory_Column-list")
          .slideToggle(300);
      }
    });
  },
  methods: {
    goTop() {
      $(document.documentElement).animate(
        {
          scrollTop: 0
        },
        300
      );
    }
  }
};
</script>
<style>
</style>
<style scoped>
@media screen and (max-width: 769px) {
  .st-FtPress-contactus {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
  }
}

@media screen and (min-width: 769px) {
  .st-FtLegal_Sites:not(:last-child):after {
    content: "";
    width: 1px;
    height: 175px;
    background-color: #4d4d4d;
    position: absolute;
    right: 0;
    bottom: 0;
  }
}

.st-FtLegal {
  background-color: #121212;
}

.st-Footer {
  padding: 40px 0 0;
}

@media screen and (min-width: 769px) {
  .st-Footer {
    padding: 80px 0 0;
  }
}

.st-FtLegal_Sites-link a[target="_blank"]:after {
  color: #fff;
  font-size: 0rem;
  line-height: 1em;
  letter-spacing: 0;
  padding-left: 6px;
  vertical-align: baseline;
}

.st-FtLegal_Link a:hover {
  color: #fff;
  text-decoration: none;
}

.st-FtLegal_Sites-link a:hover {
  color: #fff;
  text-decoration: none;
}

.st-FtPress_Logo a:after {
  font-size: 0rem;
}

.st-FtPress_Slide >>> .swiper-slide {
  width: 146.316px !important;
}

.st-FtPress_Slide >>> img {
  object-fit: cover;
  height: 196.316px !important;
}

a {
  border-bottom-style: none;
}

.el-icon-arrow-up {
  font-size: 15px;
  margin-left: 14px;
  margin-top: 13px;
  font-weight: bold;
}

@media screen and (min-width: 769px) {
  .el-icon-arrow-up {
    font-size: 25px;
    margin-left: 15px;
    margin-top: 13px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/copyright.vue